import initialState from './initialState';
import { reducer as sendMessage } from './sendMessage';

const reducers = [sendMessage];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/login/redux/reducer.js